import { css } from 'lit';
const styles = css`.cre8-u-content-knockout-brand {
  color: var(--cre8-color-content-knockout-brand);
}

.cre8-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

.cre8-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

@media all and (min-width: 23.4375rem) {
  .cre8-u-hide-sm {
    display: none !important;
  }
}
@media all and (min-width: 35rem) {
  .cre8-u-hide-sm-2 {
    display: none !important;
  }
}
@media all and (min-width: 48rem) {
  .cre8-u-hide-md {
    display: none !important;
  }
}
@media all and (min-width: 60rem) {
  .cre8-u-hide-lg {
    display: none !important;
  }
}
@media all and (min-width: 75rem) {
  .cre8-u-hide-xl {
    display: none !important;
  }
}
@media all and (max-width: 23.4375rem) {
  .cre8-u-show-sm {
    display: none !important;
  }
}
@media all and (max-width: 35rem) {
  .cre8-u-show-sm-2 {
    display: none !important;
  }
}
@media all and (max-width: 48rem) {
  .cre8-u-show-md {
    display: none !important;
  }
}
@media all and (max-width: 60rem) {
  .cre8-u-show-lg {
    display: none !important;
  }
}
@media all and (max-width: 75rem) {
  .cre8-u-show-xl {
    display: none !important;
  }
}
.cre8-u-margin-none {
  margin: 0 !important;
}

.cre8-u-margin-sm {
  margin: 0.5rem !important;
}

.cre8-u-margin-md {
  margin: 1rem !important;
}

.cre8-u-margin-lg {
  margin: 1.5rem !important;
}

.cre8-u-margin-xl {
  margin: 2rem !important;
}

.cre8-u-margin-xxl {
  margin: 4rem !important;
}

.cre8-u-margin-top-none {
  margin-top: 0 !important;
}

.cre8-u-margin-top-sm {
  margin-top: 0.5rem !important;
}

.cre8-u-margin-top-md {
  margin-top: 1rem !important;
}

.cre8-u-margin-top-lg {
  margin-top: 1.5rem !important;
}

.cre8-u-margin-top-xl {
  margin-top: 2rem !important;
}

.cre8-u-margin-top-xxl {
  margin-top: 4rem !important;
}

.cre8-u-margin-right-none {
  margin-right: 0 !important;
}

.cre8-u-margin-right-sm {
  margin-right: 0.5rem !important;
}

.cre8-u-margin-right-md {
  margin-right: 1rem !important;
}

.cre8-u-margin-right-lg {
  margin-right: 1.5rem !important;
}

.cre8-u-margin-right-xl {
  margin-right: 2rem !important;
}

.cre8-u-margin-right-xxl {
  margin-right: 4rem !important;
}

.cre8-u-margin-bottom-none {
  margin-bottom: 0 !important;
}

.cre8-u-margin-bottom-sm {
  margin-bottom: 0.5rem !important;
}

.cre8-u-margin-bottom-md {
  margin-bottom: 1rem !important;
}

.cre8-u-margin-bottom-lg {
  margin-bottom: 1.5rem !important;
}

.cre8-u-margin-bottom-xl {
  margin-bottom: 2rem !important;
}

.cre8-u-margin-bottom-xxl {
  margin-bottom: 4rem !important;
}

.cre8-u-margin-bottom-xl-xxl {
  margin-bottom: 2rem !important;
}

@media all and (min-width: 768px) {
  .cre8-u-margin-bottom-xl-xxl {
    margin-bottom: 4rem !important;
  }
}
.cre8-u-margin-left-none {
  margin-left: 0 !important;
}

.cre8-u-margin-left-sm {
  margin-left: 0.5rem !important;
}

.cre8-u-margin-left-md {
  margin-left: 1rem !important;
}

.cre8-u-margin-left-lg {
  margin-left: 1.5rem !important;
}

.cre8-u-margin-left-xl {
  margin-left: 2rem !important;
}

.cre8-u-margin-left-xxl {
  margin-left: 4rem !important;
}

.cre8-u-padding-none {
  padding: 0 !important;
}

.cre8-u-padding-sm {
  padding: 0.5rem !important;
}

.cre8-u-padding-md {
  padding: 1rem !important;
}

.cre8-u-padding-lg {
  padding: 1.5rem !important;
}

.cre8-u-padding-xl {
  padding: 2rem !important;
}

.cre8-u-padding-xxl {
  padding: 4rem !important;
}

.cre8-u-padding-top-none {
  padding-top: 0 !important;
}

.cre8-u-padding-top-sm {
  padding-top: 0.5rem !important;
}

.cre8-u-padding-top-md {
  padding-top: 1rem !important;
}

.cre8-u-padding-top-lg {
  padding-top: 1.5rem !important;
}

.cre8-u-padding-top-xl {
  padding-top: 2rem !important;
}

.cre8-u-padding-top-xxl {
  padding-top: 4rem !important;
}

.cre8-u-padding-right-none {
  padding-right: 0 !important;
}

.cre8-u-padding-right-sm {
  padding-right: 0.5rem !important;
}

.cre8-u-padding-right-md {
  padding-right: 1rem !important;
}

.cre8-u-padding-right-lg {
  padding-right: 1.5rem !important;
}

.cre8-u-padding-right-xl {
  padding-right: 2rem !important;
}

.cre8-u-padding-right-xxl {
  padding-right: 4rem !important;
}

.cre8-u-padding-bottom-none {
  padding-bottom: 0 !important;
}

.cre8-u-padding-bottom-sm {
  padding-bottom: 0.5rem !important;
}

.cre8-u-padding-bottom-md {
  padding-bottom: 1rem !important;
}

.cre8-u-padding-bottom-lg {
  padding-bottom: 1.5rem !important;
}

.cre8-u-padding-bottom-xl {
  padding-bottom: 2rem !important;
}

.cre8-u-padding-bottom-xxl {
  padding-bottom: 4rem !important;
}

.cre8-u-padding-left-none {
  padding-left: 0 !important;
}

.cre8-u-padding-left-sm {
  padding-left: 0.5rem !important;
}

.cre8-u-padding-left-md {
  padding-left: 1rem !important;
}

.cre8-u-padding-left-lg {
  padding-left: 1.5rem !important;
}

.cre8-u-padding-left-xl {
  padding-left: 2rem !important;
}

.cre8-u-padding-left-xxl {
  padding-left: 4rem !important;
}

.cre8-u-display-flex {
  display: flex !important;
}

.cre8-u-display-block {
  display: block !important;
}

body {
  font-family: var(--cre8-typography-body-default-font-family);
  font-size: var(--cre8-typography-body-default-font-size);
  font-weight: var(--cre8-typography-body-default-font-weight);
  line-height: var(--cre8-typography-body-default-line-height);
  text-decoration: var(--cre8-typography-body-default-text-decoration);
  text-transform: var(--cre8-typography-body-default-text-transform);
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  color: var(--cre8-color-content-default);
  background: var(--cre8-color-bg-default);
}

@media all and (min-width: 60rem) {
  .page-container {
    background: linear-gradient(90deg, #fff 0, #fff 66.66%, #f8f8f9 0, #f8f8f9 0);
  }
}
.band__inner {
  margin-left: 2rem;
  margin-right: 2rem;
}

@media all and (min-width: 60rem) {
  .band__inner {
    margin-right: 0;
  }
}
img {
  max-width: 100%;
  height: auto;
}

/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:root {
  --size-base-unit: 0.5rem;
  --cre8-l-max-width: 82.5rem;
  /* 1 */
  --cre8-l-linelength-width: 42rem;
  /* 1 */
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to-right" or "to-left" need to be switched to using deg values.
 * 3) Inverse items that have 45degs
 */
[dir=rtl] {
  --rtlTranslateX: 50%;
  /* 1 */
  --rtlGradientToRight: 270deg;
  /* 2 */
  --rtlRotate45Inverse: -45deg;
  /* 3 */
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements with an error status
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
* Focus state for themes that need a dashed outline for focus
* state
**/
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
/*
=======
Animations
=======
*/
:host {
  --cre8-z-index-1: 1;
  --cre8-z-index-50: 50;
  --cre8-z-index-100: 100;
  --cre8-z-index-200: 200;
  --cre8-z-index-1030: 1030;
  --cre8-anim-fade-quick: 0.35s;
  --cre8-anim-ease: ease;
}

@keyframes fadeIn {
  100% {
    opacity: 1;
  }
}
@keyframes slideIn {
  100% {
    transform: translateX(0);
  }
}
@keyframes slideInFwd {
  100% {
    width: 272px;
    height: 272px;
  }
}
@keyframes slideOutRight {
  100% {
    width: 272px;
    height: 272px;
  }
}
@keyframes slideUp {
  100% {
    transform: translateY(0);
  }
}
@media (width >= 481px) {
  @keyframes slideInFwd {
    100% {
      width: 417px;
      height: 417px;
    }
  }
  @keyframes slideOutRight {
    100% {
      width: 417px;
      height: 417px;
    }
  }
}
@media (width >= 48rem) {
  @keyframes slideInFwd {
    100% {
      width: 330px;
      height: 330px;
    }
  }
  @keyframes slideOutRight {
    100% {
      width: 330px;
      height: 330px;
      transform: translateX(calc(100vw - 45px));
    }
  }
}
@media (width >= 60rem) {
  @keyframes slideInFwd {
    100% {
      width: 460px;
      height: 460px;
    }
  }
  @keyframes slideOutRight {
    100% {
      width: 460px;
      height: 460px;
      transform: translateX(calc(100vw - 45px));
    }
  }
}
@media (width >= 75rem) {
  @keyframes slideInFwd {
    100% {
      width: 592px;
      height: 591px;
    }
  }
  @keyframes slideOutRight {
    100% {
      width: 592px;
      height: 591px;
      transform: translateX(calc(100vw - 45px));
    }
  }
}
@media (width >= 87.5rem) {
  @keyframes slideOutRight {
    100% {
      width: 592px;
      height: 591px;
      transform: translateX(calc(100vw - 120px));
    }
  }
}
@media (width >= 2200px) {
  @keyframes slideOutRight {
    100% {
      width: 592px;
      height: 591px;
      transform: translateX(calc(100vw - 592px));
    }
  }
}
span.ripple {
  position: absolute;
  border-radius: 50%;
  transform: scale(0);
  animation: ripple 600ms linear;
  background-color: var(--ripple-bg-color);
}

@keyframes ripple {
  to {
    transform: scale(4);
    opacity: 1;
  }
}
:root {
  --size-base-unit: 0.5rem;
  --cre8-l-max-width: 82.5rem;
  /* 1 */
  --cre8-l-linelength-width: 42rem;
  /* 1 */
}

/**
 * RTL support for values logical properties can't automatically adjust for
 * 1) Percentage based horizontal translate values need to be flipped
 * 2) Background gradients using "to-right" or "to-left" need to be switched to using deg values.
 * 3) Inverse items that have 45degs
 */
[dir=rtl] {
  --rtlTranslateX: 50%;
  /* 1 */
  --rtlGradientToRight: 270deg;
  /* 2 */
  --rtlRotate45Inverse: -45deg;
  /* 3 */
}

/**
 * Visible focus outline for elements on a light background
 */
/**
 * Visible focus outline for elements with an error status
 */
/**
 * Visible focus outline for elements on a dark background
 */
/**
* Focus state for themes that need a dashed outline for focus
* state
**/
/**
 * Invisible focus outline for elements that need a more visible
 * focus state for high-contrast mode
 */
/**
 * Visually hidden from display
 */
:host {
  display: block;
}

.cre8-c-multi-select {
  position: relative;
}

/**
 * Label
 */
.cre8-c-multi-select__label {
  font-family: var(--cre8-typography-label-small-font-family);
  font-size: var(--cre8-typography-label-small-font-size);
  font-weight: var(--cre8-typography-label-small-font-weight);
  line-height: var(--cre8-typography-label-small-line-height);
  text-decoration: var(--cre8-typography-label-small-text-decoration);
  text-transform: var(--cre8-typography-label-small-text-transform);
  display: block;
  margin-bottom: 0.5rem;
  margin-left: var(--cre8-input-label-margin-left, 0px);
}

/**
 * Body
 * 1) The div that contains the input and icons
 */
.cre8-c-multi-select__body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  font-family: var(--cre8-typography-body-default-font-family);
  font-size: var(--cre8-typography-body-default-font-size);
  font-weight: var(--cre8-typography-body-default-font-weight);
  line-height: var(--cre8-typography-body-default-line-height);
  text-decoration: var(--cre8-typography-body-default-text-decoration);
  text-transform: var(--cre8-typography-body-default-text-transform);
  outline: var(--cre8-border-width-focus) solid transparent;
  outline-offset: 0.125rem;
  --size-base-unit: .5rem;
  -webkit-appearance: none;
  width: 100%;
  border-width: var(--cre8-border-width-default);
  border-style: solid;
  border-color: var(--cre8-color-border-strong);
  border-radius: var(--cre8-border-radius-default);
  padding: var(--cre8-input-padding, 0.75rem 0.5rem);
  color: var(--cre8-color-content-default);
  background-color: var(--cre8-color-bg-default);
  transition: outline-color var(--cre8-anim-fade-quick) var(--cre8-anim-ease), border-color var(--cre8-anim-fade-quick) var(--cre8-anim-ease), background-color var(--cre8-anim-fade-quick) var(--cre8-anim-ease), color var(--cre8-anim-fade-quick) var(--cre8-anim-ease);
  /**
   * Hover, focus, active, and focus-visible styles for default input elements
   */
}
.cre8-c-multi-select__body:hover:not(:disabled), .cre8-c-multi-select__body:focus:not(:disabled), .cre8-c-multi-select__body:active:not(:disabled), .cre8-c-multi-select__body:focus-visible {
  outline: var(--cre8-border-width-focus) solid var(--cre8-color-border-active-outline);
  outline-offset: 0.125rem;
  /**
   * Error state
   */
}
.cre8-is-error .cre8-c-multi-select__body:hover:not(:disabled), .cre8-is-error .cre8-c-multi-select__body:focus:not(:disabled), .cre8-is-error .cre8-c-multi-select__body:active:not(:disabled), .cre8-is-error .cre8-c-multi-select__body:focus-visible {
  outline-color: var(--cre8-color-border-error);
}
.cre8-c-multi-select__body:hover:not(:disabled), .cre8-c-multi-select__body:focus:not(:disabled), .cre8-c-multi-select__body:active:not(:disabled), .cre8-c-multi-select__body:focus-visible {
  /**
   * Success state
   */
}
.cre8-is-success .cre8-c-multi-select__body:hover:not(:disabled), .cre8-is-success .cre8-c-multi-select__body:focus:not(:disabled), .cre8-is-success .cre8-c-multi-select__body:active:not(:disabled), .cre8-is-success .cre8-c-multi-select__body:focus-visible {
  outline-color: var(--cre8-color-border-success);
}
.cre8-c-multi-select__body {
  /**
   * Disabled styles for default input elements
   */
}
.cre8-c-multi-select__body:disabled {
  background-color: var(--cre8-color-bg-disabled);
  border-color: var(--cre8-color-border-disabled);
  color: var(--cre8-color-content-disabled);
  cursor: not-allowed;
  /**
   * Disabled text colors
   */
}
.cre8-c-multi-select__body:disabled::placeholder {
  color: var(--cre8-color-content-disabled);
}
.cre8-c-multi-select__body {
  /**
   * Placeholder styles for default input elements
   */
}
.cre8-c-multi-select__body::placeholder {
  color: var(--cre8-color-content-subtle);
}
.cre8-c-multi-select__body {
  /**
   * Error state for default input elements
   */
}
.cre8-is-error .cre8-c-multi-select__body {
  border-color: var(--cre8-color-border-error);
}
.cre8-c-multi-select__body {
  /**
   * Success state for default input elements
   */
}
.cre8-is-success .cre8-c-multi-select__body {
  border-color: var(--cre8-color-border-success);
}
.cre8-c-multi-select__body {
  padding: var(--cre8-spacing-8);
  padding-inline-end: 2.75rem;
  min-width: 240px;
  cursor: pointer;
  min-height: 3rem;
  height: fit-content;
}
.cre8-is-disabled .cre8-c-multi-select__body {
  box-shadow: none;
  background-color: var(--cre8-color-bg-disabled);
  border-color: var(--cre8-color-border-disabled);
  cursor: not-allowed;
  outline: none;
}
.cre8-is-disabled .cre8-c-multi-select__body:hover, .cre8-is-disabled .cre8-c-multi-select__body:focus, .cre8-is-disabled .cre8-c-multi-select__body:active, .cre8-is-disabled .cre8-c-multi-select__body:focus-visible {
  outline: none;
  background-color: var(--cre8-color-bg-disabled);
  border-color: var(--cre8-color-border-disabled);
  color: var(--cre8-color-content-disabled);
}
.cre8-is-disabled .cre8-c-multi-select__body .cre8-c-multi-select__content {
  border-color: var(--cre8-color-border-disabled);
}

.cre8-c-multi-select__content {
  display: flex;
  min-height: 30px;
  width: 100%;
  border-right: var(--cre8-border-width-default) var(--cre8-border-style-default) var(--cre8-color-border-strong);
  padding-right: 2.75rem;
}

.cre8-c-multi-select__tag-wrapper {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  gap: 0.25rem;
}

.cre8-c-multi-select__icons-wrapper {
  display: flex;
  justify-content: end;
  margin-right: -36px;
  margin-left: -48px;
  gap: 1.5rem;
  min-width: 96px;
}
.cre8-c-multi-select__icons-wrapper button {
  background-color: inherit;
  border: none;
  padding: none;
}
.cre8-is-disabled .cre8-c-multi-select__icons-wrapper button {
  cursor: not-allowed;
}

.cre8-c-multi-select--no-clear-icon .cre8-c-multi-select__clear_icon {
  display: none;
}

/**
 * Select Icon
 * 1) The icons within the body container positioned absolutely over the input
 */
cre8-icon {
  display: flex;
  pointer-events: none;
  color: var(--cre8-color-button-tertiary-content);
}
.cre8-is-disabled cre8-icon {
  color: var(--cre8-color-border-disabled);
}

.cre8-c-multi-select__dropdown {
  background-color: var(--cre8-color-bg-default);
  border: var(--cre8-border-width-default) var(--cre8-border-style-default) var(--cre8-color-border-strong);
  box-shadow: var(--cre8-shadow-default);
  border-radius: var(--cre8-border-radius-container) var(--cre8-border-radius-container);
  flex-direction: column;
  left: 0;
  min-width: 100%;
  position: absolute;
  top: 100%;
  white-space: nowrap;
  margin-top: var(--cre8-spacing-4);
  margin-left: 0;
  padding: var(--cre8-spacing-8);
}
.cre8-c-multi-select__dropdown ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.cre8-c-multi-select__dropdown li {
  font-family: var(--cre8-typography-body-default-font-family);
  font-size: var(--cre8-typography-body-default-font-size);
  font-weight: var(--cre8-typography-body-default-font-weight);
  line-height: var(--cre8-typography-body-default-line-height);
  text-decoration: var(--cre8-typography-body-default-text-decoration);
  text-transform: var(--cre8-typography-body-default-text-transform);
  background-color: var(--cre8-color-bg-default);
  border: var(--cre8-border-width-focus) var(--cre8-border-style-default) var(--cre8-color-border-transparent);
  border-radius: var(--cre8-border-radius-none);
  color: var(--cre8-color-content-default);
  width: 100%;
  cursor: pointer;
  margin: var(--cre8-spacing-0);
  padding: var(--cre8-spacing-8) var(--cre8-spacing-8);
  text-align: left;
}
.cre8-c-multi-select__dropdown li:active, .cre8-c-multi-select__dropdown li:hover, .cre8-c-multi-select__dropdown li:focus {
  background-color: var(--cre8-color-bg-brand-hover);
  color: var(--cre8-color-content-default);
  outline: var(--cre8-border-width-none);
  border: var(--cre8-border-width-focus) var(--cre8-border-style-default) var(--cre8-color-border-active-outline);
}

/**
 * Select field notes
 */
.cre8-c-multi-select__field-note,
.cre8-c-multi-select__field-note-success,
.cre8-c-multi-select__field-note-error {
  flex-basis: 100%;
}`;
export default styles;
